import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Params, RouterLink } from "@angular/router";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { TableAction } from "../sortable-table/sortable-table.component";

@Component({
  selector: "app-action-group",
  standalone: true,
  imports: [CommonModule, NgbTooltip, RouterLink],
  templateUrl: "./action-group.component.html",
  styleUrl: "./action-group.component.scss",
})
export class ActionGroupComponent<T> {
  @Input() actions?: TableAction<T>[] = [];
  @Input() row!: T;
  @Input() isDisabled?: (r: T) => boolean;
  @Input() index!: number;

  getIcon(action: any, row: any): string {
    if (typeof action.icon === "function") {
      // If action.icon is a function, call it and return the result
      return action.icon(row);
    } else {
      // If action.icon is a string, return it as is
      return action.icon;
    }
  }

  getLabel(action: any, row: any): string {
    if (typeof action.label === "function") {
      // If action.label is a function, call it and return the result
      return action.label(row);
    } else {
      // If action.label is a string, return it as is
      return action.label;
    }
  }

  getRouterLink(action: any, row: any): string {
    if (typeof action.routerLink === "function") {
      // If action.routerLink is a function, call it and return the result
      return action.routerLink(row);
    } else {
      // If action.routerLink is a string, return it as is
      return action.routerLink;
    }
  }

  getQueryParams(action: any, row: any): Params {
    if (typeof action.queryParams === "function") {
      // If action.queryParams is a function, call it and return the result
      return action.queryParams(row);
    } else {
      return action.queryParams;
    }
  }
}
